module.exports = __webpack_public_path__ + "static/img/铸造.441f8ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/铸造.jpg
// module id = c9Zj
// module chunks = 1